import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';

export interface VoColumnFilter {
  readonly id: string;
  readonly value: any;
  readonly label?: string;
  readonly isDisabled?: boolean;
  readonly isInvalid?: boolean;
}

@Component({
  selector: 'asax-result-table-vo-table-column-filter',
  templateUrl: './vo-table-column-filter.component.html',

  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [`
    .text-decoration-underline-hover:hover {
      cursor: pointer;
      text-decoration: underline !important;
    }

    .text-decoration-filter-disabled {
      text-decoration: line-through !important;
    }

    .text-decoration-filter-disabled:hover {
      cursor: pointer;
      text-decoration: underline line-through !important;
    }
  `]
})
export class VoTableColumnFilterComponent {
  @Input() columnFilter: VoColumnFilter;

  @Output() outColumnFilter = new EventEmitter<VoColumnFilter>();
  @Output() outRemoveColumnFilter = new EventEmitter<string>();

  label: string;

  removeColumnFilter(): void {
    this.outRemoveColumnFilter.emit(this.columnFilter.id);
  }

  toggleColumnFilterIsDisable(): void {
    this.columnFilter = {...this.columnFilter, isDisabled: !this.columnFilter.isDisabled};
    this.outColumnFilter.emit(this.columnFilter);
  }
}
